(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-header"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('bb-drawer');
    var overlay = document.getElementById('bb-overlay');
    var hamBtn = document.getElementById('bb-ham');
    var allBtn = document.getElementById('allbtn');
    var closeBtn = document.getElementById('bb-dx');

    function openDrawer() {
      if (drawer) drawer.classList.add('bb-open');
      if (overlay) overlay.classList.add('bb-open');
      if (hamBtn) hamBtn.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      if (drawer) drawer.classList.remove('bb-open');
      if (overlay) overlay.classList.remove('bb-open');
      if (hamBtn) hamBtn.setAttribute('aria-expanded', 'false');
    }
    if (hamBtn) hamBtn.addEventListener('click', openDrawer);
    if (allBtn) allBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.querySelectorAll('.bb-macc-h').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = document.getElementById('bb-acc-' + btn.dataset.acc);
        var isOpen = body.classList.contains('bb-open');
        document.querySelectorAll('.bb-macc-b').forEach(function (b) { b.classList.remove('bb-open'); });
        document.querySelectorAll('.bb-macc-h .bb-chev').forEach(function (c) { c.textContent = '+'; });
        document.querySelectorAll('.bb-macc-h').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (!isOpen) {
          body.classList.add('bb-open');
          btn.querySelector('.bb-chev').textContent = '–';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Nav-surface analytics (D-nav-analytics, 29 Jul). ONE event, four surfaces:
    // 'circle' (a.cat rows), 'dropdown' (.bb-dd panels), 'drawer' (.bb-drawer),
    // 'subnav' (bare top-bar word). GA4 segments bb_nav_tap by surface + device
    // to answer "which nav do people actually use". Circles ALSO keep firing
    // bb_circle_tap from bb-coffee.js — both stay; do not dedupe one away.
    document.addEventListener('click', function (evt) {
      var a = evt.target.closest && evt.target.closest('.bb-dd a, .bb-drawer a, a.bb-subnav-link, a.cat');
      if (!a) return;
      var surface = 'subnav';
      if (a.classList.contains('cat')) { surface = 'circle'; }
      else if (a.closest('.bb-dd')) { surface = 'dropdown'; }
      else if (a.closest('.bb-drawer')) { surface = 'drawer'; }
      try {
        if (window.gtag) window.gtag('event', 'bb_nav_tap', {
          surface: surface,
          target_url: a.getAttribute('href') || '',
          link_text: (a.textContent || '').trim().slice(0, 60)
        });
      } catch (e) {}
    });

    // Country picker (20 Aug 2026) — replaces the emirate picker.
    // Open/close only. Choosing a country is a real form submit to Shopify's
    // localization endpoint, so there is no client-side state to persist and
    // nothing to write to localStorage — the page reloads in the new market.
    // assets/bb-ux-fixes.js binds these same ids for Escape and focus trapping;
    // both copies are null-guarded, so they coexist safely.
    var eOverlay = document.getElementById('bb-emirate-overlay');
    var eSheet = document.getElementById('bb-emirate-sheet');
    var eClose = document.getElementById('bb-emirate-close');
    var triggers = [document.getElementById('bb-loc-trigger'), document.getElementById('bb-deliver-trigger')].filter(Boolean);

    function openSheet() {
      if (!eSheet) return;
      eSheet.classList.add('bb-open');
      if (eOverlay) eOverlay.classList.add('bb-open');
    }
    function closeSheet() {
      if (!eSheet) return;
      eSheet.classList.remove('bb-open');
      if (eOverlay) eOverlay.classList.remove('bb-open');
    }

    triggers.forEach(function (t) {
      t.classList.add('bb-js-ready');
      t.setAttribute('tabindex', '0');
      t.addEventListener('click', openSheet);
      t.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter' || evt.key === ' ') { evt.preventDefault(); openSheet(); }
      });
    });
    if (eClose) eClose.addEventListener('click', closeSheet);
    if (eOverlay) eOverlay.addEventListener('click', closeSheet);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('bbh-slideshow');
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.bbh-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.bbh-dot'));
    var arrowL = document.getElementById('bbh-arrow-l');
    var arrowR = document.getElementById('bbh-arrow-r');
    if (slides.length < 2) return;
    var current = 0;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('bbh-slide-on', i === current); });
      dots.forEach(function (d, i) {
        d.classList.toggle('bbh-dot-on', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }
    if (arrowL) arrowL.addEventListener('click', function () { show(current - 1); });
    if (arrowR) arrowR.addEventListener('click', function () { show(current + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-dot-index'), 10)); });
    });

    // Touch swipe — no autoplay, per Salem's call (homepage-tighten-v2 mockup, note 3).
    var track = document.getElementById('bbh-slides');
    var startX = null;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-home-rails"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tabs = document.querySelectorAll('[data-bbh-tab]');
    var rails = document.querySelectorAll('[data-bbh-rail]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-bbh-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('bbh-on', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        rails.forEach(function (r) {
          r.classList.toggle('bbh-on', r.getAttribute('data-bbh-rail') === key);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-home-trust"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var trigger = document.getElementById('bbh-bnpl-trigger');
    var sheet = document.getElementById('bbh-bnpl-sheet');
    var overlay = document.getElementById('bbh-bnpl-overlay');
    var close = document.getElementById('bbh-bnpl-close');
    if (!trigger || !sheet) return;
    function open() { sheet.classList.add('bbh-open'); if (overlay) overlay.classList.add('bbh-open'); }
    function shut() { sheet.classList.remove('bbh-open'); if (overlay) overlay.classList.remove('bbh-open'); }
    trigger.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    if (overlay) overlay.addEventListener('click', shut);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
